import { NavLink } from 'react-router-dom';

import dropoffIcon from '../../../assets/icons/dropoffs.svg';
import greaseTrapIcon from '../../../assets/icons/grease-trap.svg';

type Props = {
  sidebarOpen: boolean;
  isSecondaryDropoffsOpen: boolean;
};

const SecondarySideBarDropoffs = ({
  sidebarOpen,
  isSecondaryDropoffsOpen,
}: Props) => {
  return (
    <div
      className={`fixed z-30 hidden h-full w-[58px] transition-all duration-1000 ${
        sidebarOpen ? 'ml-[212px]' : 'ml-[58px]'
      }  ${isSecondaryDropoffsOpen ? 'flex flex-row ' : 'hidden'}`}
    >
      <nav className="flex w-full flex-col justify-center bg-greenextralight pt-6 text-white">
        <div className="relative my-10">
          <div className="flex items-center justify-center">
            <ul className="flex flex-col items-center gap-6">
              <li className="mb-6">
                <NavLink
                  to="/dashboard/dropoffs/oil"
                  end
                  className={({ isActive }) =>
                    isActive
                      ? 'navLinkActive flex gap-2 items-center titleAttr'
                      : 'navLinkInactive flex gap-2 items-center titleAttr'
                  }
                  data-title="Oil Dropoffs"
                >
                  <img className="h-[22px]" src={dropoffIcon} alt="dropoffs" />
                </NavLink>
              </li>

              <li className="mb-6">
                <NavLink
                  to="/dashboard/dropoffs/grease-trap"
                  end
                  className={({ isActive }) =>
                    isActive
                      ? 'navLinkActive flex gap-2 items-center titleAttr'
                      : 'navLinkInactive flex gap-2 items-center titleAttr'
                  }
                  data-title="Grease Traps"
                >
                  <img
                    className="h-[22px]"
                    src={greaseTrapIcon}
                    alt="grease traps"
                  />
                </NavLink>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </div>
  );
};

export default SecondarySideBarDropoffs;
